export default "__VITE_ASSET__6h$I_LVk__"